import { toastr } from 'react-redux-toastr';
import { CURRENCY_RATE_ENDPOINT } from '../../config/endpoints';
import { 
  CLEAR_CURRENCY_RATE,
  FLAG_GETTING_CURRENCY_RATE,
  GET_CURRENCY_RATE
} from '../types/sap-service-layer';
import { DEFAULT_POST_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingCurrencyRate = (flag) => (dispatch) =>
  dispatch({ type: FLAG_GETTING_CURRENCY_RATE, payload: flag });

const getCurrencyRate = ({
  date,
  currency
}) => async (dispatch) => {
  try {
    dispatch(flagGettingCurrencyRate(true));
    const url = CURRENCY_RATE_ENDPOINT;
    const body = JSON.stringify({ date, currency });
    const response = await fetch(url, {
      ...DEFAULT_POST_CONFIG,
      body,
    });
    await isErrorResponse(response, null, dispatch);
    const payload = await response.json();
    dispatch({ type: GET_CURRENCY_RATE, payload });
  } catch (error) {
    toastr.error('Error', 'No se pudo obtener la tasa de cambio');
  } finally {
    dispatch(flagGettingCurrencyRate(false));
  }
};

const clearCurrencyRate = () => (dispatch) =>
  dispatch({ type: CLEAR_CURRENCY_RATE });

export {
  getCurrencyRate,
  flagGettingCurrencyRate,
  clearCurrencyRate
}